<template>
  <div class="input-phone">
    <input-item v-model="phone.phone1" type="text" class="-xs" :tabindex="tabindex1" @input="updateValue" :maxlength="6" :id="`${id}_1`" :tracking-name="`${trackingName}_1`"></input-item>
    <input-append class="-xs">ー</input-append>
    <input-item v-model="phone.phone2" type="text" class="-xs" :tabindex="tabindex2" @input="updateValue" :maxlength="4" :id="`${id}_2`" :tracking-name="`${trackingName}_2`"></input-item>
    <input-append class="-xs">ー</input-append>
    <input-item v-model="phone.phone3" type="text" class="-xs" :tabindex="tabindex3" @input="updateValue" :maxlength="4" :id="`${id}_3`" :tracking-name="`${trackingName}_3`"></input-item>
  </div>
</template>

<script>
import InputItem from './InputItem'
import InputAppend from './InputAppend'
export default {
  name: 'input-phone',
  components: {InputAppend, InputItem},
  props: {
    phone: {
      type: Object,
      default: () => ({
        phone1: '',
        phone2: '',
        phone3: ''
      })
    },
    tabindex1: { type: String },
    tabindex2: { type: String },
    tabindex3: { type: String },
    id: {
      type: String,
      default: 'phone'
    },
    trackingName: { type: String }
  },
  data () {
    return {
    }
  },
  methods: {
    updateValue (e) {
      this.$emit('input', this.phone)
      this.$emit('change', this.phone)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .input-phone {
    @include flex(flex,flex-start,center,row,nowrap);
  }
</style>



// WEBPACK FOOTER //
// src/components/input/InputPhone.vue